export {};

$(init);

NLMK.initShare = init;

$(document).ajaxComplete(init);

function init(): void {
    const $shares = $('.share');

    if ($shares.length > 0) {
        require.ensure(['./module'], () => {
            const { eachShare } = require('./module');

            $shares.each(eachShare);

        }, 'share')
    }
}




// WEBPACK FOOTER //
// ./js/main/module/share/index.ts